<template>
  <div class="product-configure-wrapper">
    <div class="header">产品权限配置</div>
    <div class="content">
      <div class="default-box" v-if="!snuser">
        <div style="padding-right:32px">
          <div class="warning-box">
            <div class="info-box">
              <i class="iconfont iconkzt_peizhi_tz1"></i>
              <div>
                <p>您目前没有开通相关产品，暂时不需要进行产品配置。</p>
                <p>如需了解详情，联系我司销售获取产品介绍PPT、申请测试。如果还没有销售联系您，请致电400-809-3699我们为您分配。</p>
              </div>
            </div>
          </div>
        </div>
        <recommend-product :itemWidth="248" :allShow="true"></recommend-product>
      </div>
      <div class="with-product-box" v-if="snuser">
        <div class="tip-box">
          <i class="iconfont iconic_wenxintishi" style="margin-right:5px;"></i>
          <p>手机号画像、风险IP画像和移动风险感知平台可以统一使用API产品配置中的产品密钥与IP白名单。</p>
        </div>
        <div class="secret-box">
          <div class="title">产品密钥</div>
          <div class="tip-info">
            * 了解API的配置及使用方法，请前往威胁猎人
            <span @click="goDocs">文档中心</span>，查看对应API文档。
          </div>
          <div class="secret-info">
            <p class="snuser">
              <span>snuser：{{isOpen?snuser:'*****************'}}</span>
            </p>
            <p class="snkey">
              <span>snkey：{{isOpen?snkey:'*****************'}}</span>
            </p>
            <i v-if="isOpen" class="iconfont iconkzt_peizhi_yincangmiyao1" @click="isOpen=false"></i>
            <i v-if="!isOpen" class="iconfont iconbiyan" @click="isOpen=true"></i>
          </div>
        </div>
        <div class="ip-box">
          <div class="title">绑定访问IP（白名单）</div>
          <div class="tip-info">* 请先绑定用于访问API的服务器IP，威胁猎人仅接受符合IP来源的API请求。</div>
          <div class="ip-info-wrapper">
            <div
              class="info-item"
              v-for="item in ipList"
              :key="item.ip"
              @click="editIpBefore(item)"
            >
              <span>
                {{item.ip}}
                <span v-if="item.remark">（{{item.remark}}）</span>
              </span>
              <i class="iconfont iconshanchu" @click.stop="beforeDelIp(item)"></i>
            </div>
            <div class="add-btn" @click="addVisible=true">
              <i class="iconfont iconkzt_peizhi_tjIP"></i>
              <span>添加IP</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="addVisible" width="580px" :show-close="false">
      <div class="content">
        <div class="title">请添加IP白名单</div>
        <div v-show="!isBatch">
          <p class="tip">
            <span>请输入访问IP</span>
            <span class="batch-btn" @click="showBatch">批量添加</span>
          </p>
          <div class="add-ip-item" v-for="(item, index) in addIpList" :key="index">
            <el-input
              size="small"
              v-model.trim="item.ip"
              clearable
              style="width:216px;margin-right:8px;"
              @blur="checkIp(index)"
            ></el-input>
            <el-input
              size="small"
              v-model="item.remark"
              placeholder="添加备注（选填）"
              style="width:150px"
            ></el-input>
            <i
              class="iconfont iconic_qbjkyj_shanchu2 del-icon"
              v-if="index > 0"
              @click="delAddIpItem(index)"
            ></i>
            <p class="err-tip">{{ item.errTip }}</p>
          </div>
          <div class="add-ip-btn" @click="addIpItem">
            <i class="iconfont iconkzt_peizhi_tjIP1"></i>
            <span>添加</span>
          </div>
        </div>
        <div class="batch" v-show="isBatch">
          <p class="tip">
            批量输入访问IP
          </p>
          <el-input
            type="textarea"
            :rows="8"
            placeholder="请输入IP，多个IP之间用换行分隔"
            v-model="batchIp"
          >
          </el-input>
        </div>
        <div class="btn-group">
          <div class="btn" @click="closeAddModal">取消</div>
          <div class="btn" @click="handleAddIp">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="delVisible" width="580px" :show-close="false">
      <div class="content">
        <div class="title">是否删除白名单IP</div>
        <el-input clearable disabled v-model="delIp"></el-input>
        <div class="btn-group">
          <div class="btn" @click="delVisible=false">取消</div>
          <div class="btn del" @click="handleDelIp">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="editVisible" width="580px" :show-close="false">
      <div class="content">
        <div class="title">编辑IP备注</div>
        <el-input clearable disabled v-model="currentItem.ip" style="margin-bottom:20px;"></el-input>
        <el-input v-model="currentItem.remark" placeholder="请填写备注"></el-input>
        <div class="btn-group">
          <div class="btn" @click="editVisible=false">取消</div>
          <div class="btn" @click="submitEditIp">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RecommendProduct from '../../console/components/recommendProduct'
import { getKey, getIpList, addIpFun, delIpFun } from '@/services/interface'
import { DOCUMENT_CENTER } from '@/config.js'
export default {
  components: {
    RecommendProduct
  },
  data () {
    return {
      isOpen: true, // 查看秘钥
      snkey: '',
      snuser: '',
      ipList: [],
      addVisible: false,
      addIpList: [{ ip: '', remark: '', errTip: '' }],
      delVisible: false,
      delIp: '',
      editVisible: false,
      currentItem: {},
      isBatch: false,
      batchIp: ''
    }
  },
  computed: {
    product () {
      return this.$store.state.product
    }
  },
  methods: {
    /**
     * 获取产品秘钥
     */
    async getKey () {
      const res = await getKey().then((res) => {
        return res
      })
      this.snkey = res.data.snkey
      this.snuser = res.data.snuser
      if (this.snuser) {
        this.getIpList()
      }
    },

    /**
     * 获取ip列表
     */
    async getIpList () {
      const res = await getIpList().then((res) => {
        return res
      })
      if (res.data) {
        this.ipList = res.data
      } else {
        this.ipList = []
      }
    },

    /**
     * 点击某一项ip，出现编辑备注弹窗
     * @param item: {ip:string,remark:string}
     */
    editIpBefore (item) {
      this.currentItem = JSON.parse(JSON.stringify(item))
      this.editVisible = true
    },

    /**
     * 提交编辑ip备注
     */
    async submitEditIp () {
      await addIpFun([this.currentItem]).then((res) => {
        this.getIpList()
        this.editVisible = false
      }).catch(err => {
        console.log(err)
      })
    },

    /**
     * 添加一项ip
     */
    addIpItem () {
      this.addIpList.push({ ip: '', remark: '', errTip: '' })
    },

    /**
     * 删除添加ip中的某一项
     * @param index: 添加ip列表的索引
     */
    delAddIpItem (index) {
      this.addIpList.splice(index, 1)
    },

    /**
     * 关闭添加IP弹窗
     */
    closeAddModal () {
      this.addVisible = false
      this.isBatch = false
    },

    /**
     * 切换批量添加
     */
    showBatch () {
      this.isBatch = true
      this.batchIp = this.addIpList
        .filter(item => !!item.ip)
        .map(item => item.ip)
        .join('\n')
    },

    /**
     * 添加ip
     */
    async handleAddIp () {
      // let flag = true
      // this.addIpList.forEach((item, index) => {
      //   const itemFlag = this.checkIp(index)
      //   if (!itemFlag) {
      //     flag = false
      //   }
      // })
      // if (!flag) {
      //   return
      // }
      if (this.isBatch) {
        this.addIpList = this.batchIp.split('\n')
          .filter(item => !!item)
          .map(item => ({
            ip: item,
            remark: '',
            errTip: ''
          }))
      }
      this.addIpList.forEach((item) => {
        this.$delete(item, 'errTip')
      })
      await addIpFun(this.addIpList).then((res) => {
        this.getIpList()
        this.addIpList = [{ ip: '', remark: '', errTip: '' }]
        this.addVisible = false
        this.isBatch = false
      }).catch(err => {
        this.isBatch = false
        this.$message.error(err.data.msg)
        let numList = []
        if (!err.data.fields) {
          return
        }
        numList = Object.keys(err.data.fields)
        numList.forEach((item) => {
          this.$set(this.addIpList[Number(item)], 'errTip', 'IP输入有误')
        })
      })
    },

    /**
     * 点击删除ip图标
     * @param item:ip
     */
    beforeDelIp (item) {
      this.delIp = item.ip
      this.delVisible = true
    },

    /**
     * 删除ip
     */
    async handleDelIp () {
      await delIpFun({ ip: this.delIp })
      this.getIpList()
      this.delVisible = false
    },

    /**
     * 检测ip输入
     * @param index: 添加ip列表的索引
     */
    checkIp (index) {
      // var reg = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      // var value = this.addIpList[index].ip
      // var arr = value.split('/')
      // if (arr.length <= 2) {
      //   if (arr.length === 2) {
      //     if (reg.test(arr[0]) && arr[1] >= 0 && arr[1] <= 32 && arr[1] >= 16) {
      //       this.addIpList[index].errTip = ''
      //       return 1
      //     } else if (arr[1] < 16) {
      //       this.addIpList[index].errTip = ('网段不能小于16')
      //       return 0
      //     } else {
      //       this.addIpList[index].errTip = ('IP输入有误')
      //       return 0
      //     }
      //   } else if (arr.length === 1) {
      //     if (reg.test(arr[0])) {
      //       this.addIpList[index].errTip = ''
      //       return 1
      //     } else {
      //       this.addIpList[index].errTip = ('IP输入有误')
      //       return 0
      //     }
      //   }
      // } else {
      //   this.addIpList[index].errTip = ('IP输入有误')
      //   return 0
      // }
    },

    /**
     * 跳转文档中心
     */
    goDocs () {
      window.open(DOCUMENT_CENTER)
    }
  },
  created () {
    this.getKey()
    // this.getIpList()
  }
}
</script>

<style lang="scss" scoped>
.product-configure-wrapper {
  /deep/.el-dialog__header {
    padding: 0;
  }
  /deep/.el-dialog__body {
    padding: 0;
    .content {
      padding: 50px 120px 82px;
      background: #fff;
      border-radius: 8px;
      .title {
        font-size: 24px;
        font-weight: 500;
        color: rgba(59, 60, 64, 1);
        line-height: 30px;
        text-align: center;
        margin-bottom: 40px;
      }
      .tip {
        font-size: 16px;
        font-weight: 400;
        color: rgba(59, 60, 64, 1);
        line-height: 22px;
        margin-bottom: 16px;
        .batch-btn {
          color: #1376ff;
          margin-left: 15px;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .add-ip-item {
        display: flex;
        margin-bottom: 20px;
        position: relative;
        .err-tip {
          position: absolute;
          line-height: 20px;
          font-size: 12px;
          color: red;
          bottom: -20px;
          right: 148px;
        }
        .del-icon {
          position: absolute;
          font-size: 20px;
          right: -28px;
          top: 50%;
          transform: translate(0, -50%);
          cursor: pointer;
          color: rgba(0, 61, 146, 1);
        }
      }
      .add-ip-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(0, 61, 146, 1);
        color: rgba(0, 61, 146, 1);
        cursor: pointer;
        font-size: 14px;
        i {
          font-size: 12px;
          color: rgba(0, 61, 146, 1);
          margin-right: 2px;
        }
      }
      .btn-group {
        margin-top: 46px;
        display: flex;
        justify-content: space-between;
        .btn {
          width: 150px;
          height: 42px;
          border-radius: 4px;
          color: #fff;
          text-align: center;
          line-height: 42px;
          font-size: 16px;
          letter-spacing: 1px;
          font-weight: 400;
          box-sizing: border-box;
          cursor: pointer;
          &:nth-of-type(1) {
            border: 1px solid rgba(221, 221, 221, 1);
            color: rgba(176, 183, 193, 1);
          }
          &:nth-of-type(2) {
            background: rgba(0, 61, 146, 1);
          }
          &.del {
            background: rgba(239, 59, 69, 1);
          }
        }
      }
      .batch {
        .el-textarea {
          textarea {
            font-family: 'PingFangSC-Regular','微软雅黑','宋体',Arial,sans-serif;
          }
        }
      }
    }
  }
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(17, 39, 98, 0.04);
  border-radius: 4px;
  margin-bottom: 32px;
  .header {
    height: 60px;
    line-height: 60px;
    padding-left: 28px;
    border-bottom: 1px solid #e3e8ed;
    font-size: 18px;
    font-weight: 500;
    color: rgba(29, 36, 60, 1);
  }
  .content {
    padding: 32px 0 0 28px;
    .default-box {
      .warning-box {
        padding: 25px 32px;
        background: rgba(255, 243, 224, 1);
        border-radius: 3px;
        display: flex;
        align-items: center;
        margin-bottom: 49px;
        max-width: 1044px;
        i {
          color: #ffa85d;
          font-size: 30px;
          margin-right: 24px;
        }
        .info-box {
          display: flex;
          align-items: center;
          i {
            font-size: 30px;
            color: #ffa85d;
          }
          p {
            font-size: 15px;
            font-weight: 400;
            color: rgba(29, 36, 60, 1);
            line-height: 26px;
          }
        }
      }
    }
    .with-product-box {
      overflow: hidden;
      .tip-box {
        width: 743px;
        height: 34px;
        background: rgba(240, 246, 255, 1);
        padding-left: 9px;
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        i,
        p {
          font-size: 14px;
          color: #435f87;
        }
      }
      .secret-box {
        margin-bottom: 32px;
        .title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(29, 36, 60, 1);
          line-height: 22px;
          margin-bottom: 12px;
        }
        .tip-info {
          font-size: 14px;
          font-weight: 500;
          color: rgba(64, 73, 100, 1);
          line-height: 20px;
          margin-bottom: 16px;
          span {
            color: #2f82ff;
            cursor: pointer;
          }
        }
        .secret-info {
          max-width: 830px;
          height: 50px;
          display: flex;
          align-items: center;
          position: relative;
          background: rgba(240, 246, 255, 1);
          border-radius: 2px;
          padding-left: 21px;
          p {
            font-size: 14px;
            font-weight: 500;
            color: rgba(64, 73, 100, 1);
            line-height: 20px;
          }
          .snuser {
            width: 353px;
            margin-right: 50px;
          }
          i {
            position: absolute;
            font-size: 14px;
            right: 30px;
            top: 50%;
            transform: translate(0, -50%);
            color: #000;
            cursor: pointer;
          }
        }
      }
      .ip-box {
        .title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(29, 36, 60, 1);
          line-height: 22px;
          margin-bottom: 12px;
        }
        .tip-info {
          font-size: 14px;
          font-weight: 500;
          color: rgba(64, 73, 100, 1);
          line-height: 20px;
          margin-bottom: 16px;
        }
        .ip-info-wrapper {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .info-item {
            width: 411px;
            height: 50px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            border: 1px solid rgba(0, 61, 146, 1);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 36px 0 28px;
            box-sizing: border-box;
            margin-bottom: 35px;
            margin-right: 28px;
            cursor: pointer;
            i {
              color: #6f768c;
              font-size: 18px;
              cursor: pointer;
            }
            span {
              font-size: 14px;
              font-weight: 400;
              color: rgba(29, 36, 60, 1);
            }
          }
          .add-btn {
            width: 400px;
            height: 50px;
            display: flex;
            align-items: center;
            background: rgba(0, 61, 146, 1);
            border-radius: 4px;
            justify-content: center;
            color: #fff;
            cursor: pointer;
            margin-bottom: 35px;
            font-size: 16px;
            font-weight: 500;
            i {
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
}
</style>
